import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayForPareto } from "../models/DelayForPareto";

type getDelaysForParetoProps = {
	startDate: Date;
	endDate: Date;
	delayCodeId?: number | null;
	delayCategoryId?: number | null;
	shiftId?: number | null;
	crew?: string | null;
	delayAreaAssetId?: number | null;
	includeUndeclared: boolean;
};

export const getDelaysForPareto = async ({
	startDate,
	endDate,
	delayCodeId,
	delayCategoryId,
	shiftId,
	crew,
	delayAreaAssetId,
	includeUndeclared = false,
}: getDelaysForParetoProps) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: startDate },
		{ name: "End", value: endDate },
		{
			name: "DelayAreaAssetId",
			value: delayAreaAssetId || null,
		},
		{
			name: "DelayCategoryId",
			value: delayCategoryId || null,
		},
		{
			name: "DelayCodeId",
			value: delayCodeId || null,
		},
		{
			name: "ShiftId",
			value: shiftId || null,
		},
		{
			name: "Crew",
			value: crew || null,
		},
		{
			name: "IncludeUndeclared",
			value: includeUndeclared,
		},
	];

	const resp = await apiService.callV2(
		"[DEL].[GetDelaysForPareto]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayForPareto[];
	} else {
		throw new Error(resp.message || "Error fetching delays for pareto");
	}
};
